import React from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../auth";

export default function AdminLogin() {
  const { login, isAuthed } = useAdminAuth();
  const nav = useNavigate();

  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    if (isAuthed) nav("/admin");
  }, [isAuthed, nav]);

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(username.trim(), password);
      nav("/admin");
    } catch (err) {
      setError(err?.message || "Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen admin-bg flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="rounded-[32px] border border-white/10 bg-white/5 backdrop-blur-2xl shadow-2xl p-8">
          <div className="flex items-center gap-3">
            <div className="h-12 w-12 rounded-2xl bg-gradient-to-br from-blue-500 to-violet-500 grid place-items-center text-white font-bold">
              STS
            </div>
            <div>
              <div className="text-white text-xl font-semibold leading-tight">Inventory Admin</div>
              <div className="text-white/60 text-sm">Sign in to continue</div>
            </div>
          </div>

          <form onSubmit={onSubmit} className="mt-8 space-y-4">
            <div>
              <label className="text-white/70 text-sm">Username</label>
              <input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                className="mt-2 w-full rounded-2xl bg-black/30 border border-white/10 px-4 py-3 text-white placeholder-white/30
                focus:outline-none focus:ring-2 focus:ring-blue-500/60"
                placeholder="admin"
              />
            </div>

            <div>
              <label className="text-white/70 text-sm">Password</label>
              <input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                type="password"
                className="mt-2 w-full rounded-2xl bg-black/30 border border-white/10 px-4 py-3 text-white placeholder-white/30
                focus:outline-none focus:ring-2 focus:ring-blue-500/60"
                placeholder="••••••••"
              />
            </div>

            {error ? (
              <div className="rounded-2xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-red-200 text-sm">
                {error}
              </div>
            ) : null}

            <button
              disabled={busy}
              className="w-full rounded-2xl py-3 font-semibold text-white bg-gradient-to-r from-blue-500 to-violet-500
              hover:opacity-95 transition disabled:opacity-60"
            >
              {busy ? "Signing in..." : "Sign In"}
            </button>

            <div className="text-center text-white/50 text-xs">
              Protected access • JWT session
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
